import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AnleggMaaned } from 'src/app/services/forbruk/forbruk.types';
import { sumNum } from 'src/app/utils/array-utils';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-nokkeltall-month',
  templateUrl: './month.component.html',
  styleUrls: ['./month.component.scss']
})
export class NokkeltallMonthComponent implements OnInit {
  @Input() valgtMaanedAnlegg: AnleggMaaned;

  thisYear: number;
  isPlusskunde: boolean;
  forbrukThisYear: number;
  kostnadThisYear: number;
  inntekt: number;
  produksjon: number;

  constructor() {}

  ngOnInit() {
    this.calcMonthValues();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.valgtMaanedAnlegg.firstChange) {
      if (hasChanged([changes.valgtMaanedAnlegg])) {
        this.calcMonthValues();
      }
    }
  }

  calcMonthValues() {
    this.thisYear = new Date().getFullYear();
    this.isPlusskunde = this.valgtMaanedAnlegg.plusskunde;
    const thisYearList = this.valgtMaanedAnlegg.maanedVerdiList.filter(
      (x) => x.aar === this.thisYear
    );
    if (this.isPlusskunde) {
      this.forbrukThisYear = sumNum(
        thisYearList.map((x) => x.verdi - x.plussverdi)
      );
      this.kostnadThisYear = sumNum(
        thisYearList.map((x) => x.belop + x.belopPlussverdi)
      );
      this.inntekt = sumNum(thisYearList.map((x) => -x.belopPlussverdi));
      this.produksjon = sumNum(thisYearList.map((x) => x.plussverdi));
    } else {
      this.forbrukThisYear = sumNum(thisYearList.map((x) => x.verdi));
      this.kostnadThisYear = sumNum(thisYearList.map((x) => x.belop));
    }
  }

  toRoundNumber(num: number) {
    return Math.round(num).toLocaleString('nb-NO');
  }
}
